import { render, staticRenderFns } from "./SelfProfile.vue?vue&type=template&id=02f7bb8e&"
import script from "./SelfProfile.vue?vue&type=script&lang=js&"
export * from "./SelfProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports